import React from 'react';
import { Link } from 'react-router-dom';

export default function TarotTeaser() {
  return (
    <section className="tarot-teaser" aria-labelledby="tarot-teaser-heading">
      <div className="tarot-teaser__row">
        <span className="tarot-teaser__icon" aria-hidden="true">🔮</span>
        <div>
          <h2 id="tarot-teaser-heading" className="tarot-teaser__title">
            ไพ่ยิปซีเลขนำโชค — ฟรี
          </h2>
          <p className="tarot-teaser__desc">
            เปิดไพ่ 3 ใบ รับคำทำนายละเอียด แล้วเช็คเลขจากไพ่กับสถิติหวย 32 ปีทันที
            ชวนเพื่อนแชร์ผลเดียวกันได้
          </p>
          <Link to="/tarot?spread=lotto" className="tarot-teaser__cta">
            เปิดไพ่เลขนำโชค →
          </Link>
          <div className="tarot-teaser__tags">
            <span className="tarot-teaser__tag">Major Arcana 22 ใบ</span>
            <span className="tarot-teaser__tag">เชื่อมเลขเด็ด</span>
            <span className="tarot-teaser__tag">แชร์ LINE ได้</span>
          </div>
        </div>
      </div>
    </section>
  );
}
